export const getPromiseMock = () => new Promise<void>(resolve => { setTimeout(resolve, 2000) });
